<template>
  <div v-if="loading" class="loader">
    <b-spinner
      variant="primary"
      type="grow"
      :label="`${this.$t('reports.loadingLabel')}...`"
    ></b-spinner>
  </div>
  <div
    v-else
    id="categoriesTagsReport"
    class="card px-2 py-2 mt-3 wrapper-categories"
  >
    <div class="col-3">
      <b-form-group
        :label="`${this.$t('reports.categoriesTags.profileLabel')}:`"
        label-for="select-profile"
      >
        <b-select
          id="select-profile"
          v-model="selectedProfile"
          :options="optionsProfiles"
        ></b-select>
      </b-form-group>
    </div>
    <div class="col-12" v-if="selectedCategory || selectedTag">
      <button
        @click="loadAllCategories"
        class="btn btn-outline-primary icon-eraser-tag"
      >
        <i class="fas fa-eraser"></i>
        {{ $t('reports.categoriesTags.loadAllCategories') }}
      </button>
    </div>
    <div class="col-12" style="display: flex;">
      <div class="col-4">
        <highcharts :options="categoryCharOptions"></highcharts>
      </div>
      <div class="col-4">
        <highcharts :options="subCategoryCharOptions"></highcharts>
      </div>
      <div class="col-4">
        <highcharts :options="tagCharOptions"></highcharts>
      </div>
    </div>
    <div class="col-12" v-if="items.length > 0">
      <div class="row">
        <b-table
          striped
          responsive
          :fields="fields"
          :items="items"
          :per-page="20"
          :current-page="currentPage"
          id="cat-tag-answers-details"
        >
          <template>
            <b-tr>
              <b-th></b-th>
              <b-th></b-th>
              <b-th></b-th>
              <b-th></b-th>
              <b-th style="width: 80px;"></b-th>
            </b-tr>
          </template>
          <template v-slot:cell(date)="row">
            {{ dateFormat(row.item.date) }}
          </template>
          <template v-slot:cell(review)="row">
            <!-- <div class="flag-grade" :class="`flag-grade-${group}`"> -->
            <div
              class="flag-grade"
              :class="getClass(row.item.review, row.item.metric)"
            >
              {{ (row.item.review) }}
            </div>
          </template>
          <template v-slot:cell(name)="row">
            {{ returnClient(row.item.anonymousResponse, row.item.name) }}
          </template>
          <template v-slot:cell(details)="row">
            <div class="text-center">
              <div v-if="userProfile.permissions.answers.menu">
                <a :href="`/treatments/${row.item._id}`" target="_blank">
                  <i
                    style="cursor: pointer; color: #4ce595;"
                    class="fas fa-search"
                  ></i
                ></a>
              </div>
            </div>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="mt-4 mb-4">
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            per-page="20"
            aria-controls="cat-tag-answers-details"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import Paginate from 'vuejs-paginate';
import pt from 'date-fns/locale/pt';
import api from '../../../../../services/api';

export default {
  name: 'CategoriesAndTags',
  components: {
    Paginate,
  },
  data: () => ({
    userAuth: null,
    visible: true,
    total: 0,
    categoryItems: { qtd: 0 },
    subCategoryItems: { qtd: 0 },
    tagItems: { qtd: 0 },
    categories: [],
    subCategories: [],
    tags: [],
    fieldsCategories: [],
    fieldsSubCategories: [],
    fieldsTags: [],
    loading: false,
    categoriesTotal: 0,
    subCategoriesTotal: 0,
    tagsTotal: 0,
    totals: {},
    selectedCategory: null,
    selectedSubCategory: null,
    selectedTag: null,
    chartOptions: {},
    categoryCharOptions: {},
    subCategoryCharOptions: {},
    tagCharOptions: {},
    items: [],
    fields: [],
    currentPage: 0,
    selectedProfile: 'all',
    optionsProfiles: [],
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.setData();
    },
    myMetric: function watchMyMetric() {
      this.setData();
    },

    myActionId: function watchMyActionId() {
      this.setData();
    },

    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },

    myIh1: function watchMyIh1() {
      this.setData();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },

    myIh2: function watchMyIh2() {
      this.setData();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },

    calendarDates: function watchDates() {
      this.setData();
    },
    'indicatorData.value': function watchindicatorData() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
    selectedProfile: function watchSelectedProfile() {
      this.setData();
    },
  },
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('charts', ['reportCategories']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {
    ...mapActions('charts', ['getReportCategories']),
    ...mapActions('calendar', ['setDefaultDates']),
    async setData() {
      this.loading = true;
      const response = await api.get('/reports/categories-tags', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          metric: this.myMetric,
          categoryId: this.selectedCategory,
          subCategoryId: this.selectedSubCategory,
          tagId: this.selectedTag,
          profile: this.selectedProfile,
        },
      });
      if (response) {
        this.categories = response.data.categories;
        this.subCategories = response.data.subCategories;
        this.tags = response.data.tags;
        this.totals = response.data.totals;
        if (this.categories.length > 0) {
          this.categoriesTotal = this.categories[0].total;
        }
        if (this.subCategories.length > 0) {
          this.subCategoriesTotal = this.subCategories[0].total;
        }
        if (this.tags.length > 0) {
          this.tagsTotal = this.tags[0].total;
        }
        this.items = response.data.answers;
      }
      const categoriesCategory = [];
      const seriesCategory = [];
      for (let i = 0; i < this.categories.length; i += 1) {
        categoriesCategory.push(this.categories[i].name);
        seriesCategory.push({
          y: this.categories[i].total,
          perc: (
            100.0 *
            (this.categories[i].total / this.totals.categories)
          ).toFixed(2),
          categoryId: this.categories[i].id,
        });
      }
      const dataCategory = {
        categories: categoriesCategory,
        series: seriesCategory,
      };
      const categoriesSubCategory = [];
      const seriesSubCategory = [];
      for (let i = 0; i < this.subCategories.length; i += 1) {
        categoriesSubCategory.push(this.subCategories[i].name);
        seriesSubCategory.push({
          y: this.subCategories[i].total,
          perc: (
            100.0 *
            (this.subCategories[i].total / this.totals.subCategories)
          ).toFixed(2),
          categoryId: this.subCategories[i].mainCategoryId,
          subCategoryId: this.subCategories[i].id,
        });
      }
      const dataSubCategory = {
        categories: categoriesSubCategory,
        series: seriesSubCategory,
      };
      const categoriesTag = [];
      const seriesTag = [];
      for (let i = 0; i < this.tags.length; i += 1) {
        categoriesTag.push(this.tags[i].name);
        seriesTag.push({
          y: this.tags[i].total,
          perc: (100.0 * (this.tags[i].total / this.totals.tags)).toFixed(2),
          tagId: this.tags[i].id,
        });
      }
      const dataTag = {
        categories: categoriesTag,
        series: seriesTag,
      };
      this.renderChart(dataCategory, dataSubCategory, dataTag);
      this.loading = false;
    },
    async loadAllCategories() {
      this.selectedCategory = null;
      this.selectedSubCategory = null;
      this.selectedTag = null;
      await this.setData();
    },
    async clickCategory(item) {
      this.selectedCategory = item.categoryId;
      this.selectedTag = null;
      await this.setData();
    },
    async clickSubCategory(item) {
      this.selectedCategory = item.categoryId;
      this.selectedSubCategory = item.subCategoryId;
      this.selectedTag = null;
      await this.setData();
    },
    async clickTag(item) {
      this.selectedCategory = null;
      this.selectedSubCategory = null;
      this.selectedTag = item.tagId;
      await this.setData();
    },
    async renderChart(dataCategory, dataSubCategory, dataTag) {
      this.categoryCharOptions = JSON.parse(JSON.stringify(this.chartOptions));
      this.subCategoryCharOptions = JSON.parse(
        JSON.stringify(this.chartOptions),
      );
      this.tagCharOptions = JSON.parse(JSON.stringify(this.chartOptions));
      this.categoryCharOptions.title.text = this.$t(
        'reports.categoriesTags.categories',
      );
      this.categoryCharOptions.xAxis.categories = dataCategory.categories;
      this.categoryCharOptions.series[0].data = dataCategory.series;
      this.categoryCharOptions.series[0].point = {
        events: {
          click: (e) => this.clickCategory(e.point),
        },
      };
      this.categoryCharOptions.yAxis.max = this.categoriesTotal;
      this.categoryCharOptions.xAxis.max =
        dataCategory.categories.length <= 20
          ? dataCategory.categories.length
          : 20;
      if (this.categoryCharOptions.xAxis.max > 0) {
        this.categoryCharOptions.xAxis.max =
          this.categoryCharOptions.xAxis.max - 1;
      }
      this.categoryCharOptions.colors = ['#527bf2'];
      this.subCategoryCharOptions.title.text = this.$t(
        'reports.categoriesTags.subCategories',
      );
      this.subCategoryCharOptions.xAxis.categories = dataSubCategory.categories;
      this.subCategoryCharOptions.series[0].data = dataSubCategory.series;
      this.subCategoryCharOptions.series[0].point = {
        events: {
          click: (e) => this.clickSubCategory(e.point),
        },
      };
      this.subCategoryCharOptions.yAxis.max = this.subCategoriesTotal;
      this.subCategoryCharOptions.xAxis.max =
        dataSubCategory.categories.length <= 20
          ? dataSubCategory.categories.length
          : 20;
      if (this.subCategoryCharOptions.xAxis.max > 0) {
        this.subCategoryCharOptions.xAxis.max =
          this.subCategoryCharOptions.xAxis.max - 1;
      }
      this.subCategoryCharOptions.colors = ['#5299f2'];

      this.tagCharOptions.title.text = this.$t('reports.categoriesTags.tags');
      this.tagCharOptions.xAxis.categories = dataTag.categories;
      this.tagCharOptions.series[0].data = dataTag.series;
      this.tagCharOptions.series[0].point = {
        events: {
          click: (e) => this.clickTag(e.point),
        },
      };
      this.tagCharOptions.yAxis.max = this.tagsTotal;
      this.tagCharOptions.xAxis.max =
        dataTag.categories.length <= 20 ? dataTag.categories.length : 20;
      if (this.tagCharOptions.xAxis.max > 0) {
        this.tagCharOptions.xAxis.max = this.tagCharOptions.xAxis.max - 1;
      }
      this.tagCharOptions.colors = ['#7ab4f2'];
    },
    returnClient(isAnonymous, client) {
      if (this.userProfile.permissions.answers.menu) {
        if (
          isAnonymous &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return 'Anônimo';
        } else if (this.userProfile.permissions.answers.anonymous_profile) {
          return '****';
        } else if (client) {
          return client;
        }
      }

      if (this.userProfile.permissions.answers.anonymous_profile) {
        return '****';
      }

      return '****';
    },
    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },
    getClass(review, metric) {
      let group;
      if (
        metric === 'csat-1-5' ||
        metric === 'ces-1-5' ||
        metric === '5-stars'
      ) {
        switch (review.toString()) {
          case '1':
          case '2':
            group = 'detractors';
            break;
          case '3':
            group = 'neutrals';
            break;
          case '4':
          case '5':
            group = 'promoters';
            break;
          default:
            break;
        }
      } else {
        switch (review.toString()) {
          case '0':
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '6':
            group = 'detractors';
            break;
          case '7':
          case '8':
            group = 'neutrals';
            break;
          case '9':
          case '10':
            group = 'promoters';
            break;
          default:
            break;
        }
      }
      return `flag-grade-${group}`;
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fieldsCategories = [
      {
        key: 'name',
        label: this.$t('reports.categoriesTags.categories'),
        class: 'questionTags',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTags',
      },
    ];
    this.fieldsSubCategories = [
      {
        key: 'name',
        label: this.$t('reports.categoriesTags.subCategories'),
        class: 'questionTags',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTags',
      },
    ];
    this.fieldsTags = [
      {
        key: 'name',
        label: this.$t('reports.categoriesTags.tags'),
        class: 'questionTags',
      },
      {
        key: 'progress',
        label: '',
        class: 'progressTags',
      },
    ];
    this.fields = [
      { key: 'feedback', label: this.$t('reports.wordCloud.commentLabel') },
      { key: 'date', label: this.$t('reports.wordCloud.dateLabel') },
      {
        key: 'review',
        class: 'text-center',
        label: this.$t('reports.wordCloud.gradeLabel'),
      },
      { key: 'name', label: this.$t('reports.wordCloud.customerLabel') },
      {
        key: 'details',
        class: 'text-center',
        label: this.$t('reports.wordCloud.detailsLabel'),
      },
    ];
    this.chartOptions = {
      title: {
        align: 'left',
      },
      chart: {
        type: 'bar',
        borderColor: 'rgba(0, 0, 0, 0.09)',
        style: {
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
          fontSize: '12px',
          width: '100%',
        },
      },
      xAxis: {
        visible: true,
        labels: {},
      },
      yAxis: {
        gridLineWidth: 0,
        labels: {
          enabled: true,
        },
        title: {
          text: '',
        },
        stackLabels: {
          enabled: true,
          fontWeight: 'bold',
        },
      },
      series: [
        {
          name: 'Series',
          cursor: 'pointer',
        },
      ],
      legend: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          pointPadding: 0.1,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
          },
          /* */
          tooltip: {
            pointFormat: '{point.y} - {point.perc} %',
          },
          /* */
        },
        series: {
          groupPadding: 0,
          pointPadding: 0.05,
          borderWidth: 0,
          // pointWidth: 25,
        },
      },
    };
  },

  async mounted() {
    if (this.myMetric.indexOf('nps') >= 0) {
      this.optionsProfiles = [
        {
          value: 'all',
          text: this.$t('reports.categoriesTags.selProfileLabel'),
        },
        {
          value: 'promoter',
          text: this.$t('reports.categoriesTags.promoterLabel'),
        },
        {
          value: 'neutral',
          text: this.$t('reports.categoriesTags.neutralLabel'),
        },
        {
          value: 'detractor',
          text: this.$t('reports.categoriesTags.detractorLabel'),
        },
      ];
    } else {
      this.optionsProfiles = [
        {
          value: 'all',
          text: this.$t('reports.categoriesTags.selProfileLabel'),
        },
        {
          value: 'promoter',
          text: '4-5',
        },
        {
          value: 'neutral',
          text: '3',
        },
        {
          value: 'detractor',
          text: '1-2',
        },
      ];
    }
    await this.setData();
  },
};
</script>

<style lang="scss" scoped>
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-categories .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-categories .btn .btn-light .collapsed {
  background-color: transparent;
}
.progressTags {
  width: 50%;
}
.questionTags {
  width: 50%;
}
#categoriesTagsReport input[type='checkbox'] + label::before {
  content: '\f0fe';
  font-family: FontAwesome;
  display: inline-block;
  padding-right: 5px;
  color: #4ce595;
  border: none;
  margin-top: -5px;
}
#categoriesTagsReport input[type='checkbox']:checked + label::before {
  content: '\f146';
  margin-top: -5px;
  color: #4ce595 !important;
  background-color: white !important;
  z-index: 1;
}
#categoricategoriesTagsReportesReport input {
  display: none;
}
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-category {
  color: white !important;
  background-color: #4ce595 !important;
  border: 1px solid #4ce595;
}
.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 16px;
  margin-left: auto;
  margin-right: auto;
  max-width: 35px;
  max-height: 30px;
  padding: 4px;
}
.flag-grade-promoters {
  background-color: #28a745;
}
.flag-grade-detractors {
  background-color: #dc3545;
}
.flag-grade-neutrals {
  background-color: rgb(211, 211, 17);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/categoriesAndTags/index.vue